var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('comp-data-iterator',{staticClass:"pt-3",attrs:{"datos":_vm.datos,"actions":_vm.acciones,"results":_vm.params.results,"titleCard":_vm.titleCard}})}
var staticRenderFns = []

export { render, staticRenderFns }